import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { sixthAnalysesActions } from 'features/sixthAnalyses';

const useSixthAnalyses = () => {
  const dispatch = useDispatch();
  const getSixthAnalyses = useCallback(({ offset }) => dispatch(sixthAnalysesActions.getSixthAnalyses({ offset })), [dispatch]);
  const getSixthAnalysis = useCallback(({ id, cable }) => dispatch(sixthAnalysesActions.getSixthAnalysis({ id, cable })), [dispatch]);
  const createSixthAnalysis = useCallback((sixth_analysis) => dispatch(sixthAnalysesActions.createSixthAnalysis(sixth_analysis)), [dispatch]);
  const clearLocalSixthAnalyses = useCallback(() => dispatch(sixthAnalysesActions.clearLocalSixthAnalyses()), [dispatch]);
  const clearLocalActiveSixthAnalysis = useCallback(() => dispatch(sixthAnalysesActions.clearLocalActiveSixthAnalysis()), [dispatch]);

  return {
    getSixthAnalyses,
    getSixthAnalysis,
    createSixthAnalysis,
    clearLocalSixthAnalyses,
    clearLocalActiveSixthAnalysis
  };
};

export default useSixthAnalyses;